/**
 * Bookmarks
 *
 * @component bookmarks
 */

import ClassLogger from 'ClassLogger';
import Api from './_api.js';

class Workshops {

    constructor() {
        let self = this;
        self.logger = ClassLogger(self, true);
        self.baseUrl = '/processor/workshop/';
        self.view = 'standard';

        if ($('[data-workshop-button]').length === 0) {
            return;
        }
        self.init();
    }

    init() {
        let self = this;

        // Check for dashboard module
        if ($('[data-workshop-dashboard]').length === 0) {
            self.buttonsInit();
        } else {
            self.dashboard();
        }

    }

    buttonsInit() {
        let self = this;
        // remove all previous click handlers
        $('[data-workshop-button]').off('click');

        $('[data-workshop-button]').on('click', function (event) {
            const $button = $(this);
            let params = {};
            params.workshopId = $button.data('workshopid');
            params.userId = $button.data('workshopuserid');
            params.state = $button.data('workshop-button');

            const uri = '?action=web/workshop&state=' + params.state + '&workshopid=' + params.workshopId + '&userid=' + params.userId;
            const data = [];
            let buttonBackup = $button.html();
            $button.html();
            $('#javascripthelpers .c-preloader-overlay').clone().appendTo($button).show();

            // Request Data
            Api.request('GET', uri, data, self.baseUrl)
                .then(function (response) {
                    if (params.state == 'add') {
                        self.logger.log('Workshop registration successful');
                        self.markWorkshop($button);
                    } else if (params.state == 'delete') {
                        self.logger.log('Workshop deletion successful');
                        self.resetWorkshop(params.workshopId);
                        self.checkDashboardStatus();
                    }
                    $button.find('.c-preloader-overlay').remove();
                    self.countWorkshop(params.workshopId);

                }).catch(function (exception) {
                    self.logger.error('Workshop registration not successful', exception);
                    let error_message = 'Es trat ein Fehler auf!';
                    if (typeof exception === 'object'
                        && typeof exception.responseJSON === 'object'
                        && typeof exception.responseJSON.error_code !== 'undefined'
                        && typeof exception.responseJSON.error_message === 'string'
                    ) {
                        error_message = exception.responseJSON.error_message;
                    }
                    alert(error_message);
                    $button.html(buttonBackup);
                });
        });
    }

    dashboard() {
        let self = this;
        const data = [];
        // get userID
        const userId = $('[data-workshop-dashboard]').data('workshop-dashboard');
        const uri = '?action=web/dashboard&userid=' + userId;
        self.logger.log('Dashboard User ID', userId);
        if (userId) {

            // Request Data
            Api.request('GET', uri, data, self.baseUrl)
                .then(function (response) {
                    self.view = 'dashboard';

                    if (response.success) {
                        $('[data-workshop-dashboard]').removeClass('hide');
                        $('[data-workshop-dashboard] [data-workshop-output]').empty().append(response.html);
                    }

                    self.buttonsInit();

                }).catch(function (exception) {
                    self.logger.error('Workshop registration not successful', exception);
                    let error_message = 'Es trat ein Fehler auf!';
                    if (typeof exception === 'object'
                        && typeof exception.responseJSON === 'object'
                        && typeof exception.responseJSON.error_code !== 'undefined'
                        && typeof exception.responseJSON.error_message === 'string'
                    ) {
                        error_message = exception.responseJSON.error_message;
                    }
                    alert(error_message);

                });

        }
    }

    checkDashboardStatus() {
        // If we have no more items in the dashboard, hide it from view
        if ($('[data-workshop-section]').length == 0) {
            $('[data-workshop-dashboard]').addClass('hide');
        }
    }

    markWorkshop($button) {
        let self = this;
        if ($button.length === 0) {
            self.logger.error('marking workshop button not found');
            return;
        }
        $button.data('workshop-button', 'delete');
        $button.removeClass('c-button--primary');
        $button.addClass('c-button--secondary');
        $button.find('.c-button__label').text('Abmelden');
        $button.find('.c-button__icon-background').removeClass('c-button__icon-background--icon-register');
        $button.find('.c-button__icon-background').addClass('c-button__icon-background--icon-delete');

        if (self.view == 'dashboard') {
            // initiate new dashboard
            self.dashboard();
        }
    }

    resetWorkshop(workshopId) {
        let self = this;
        let $button = $('[data-workshop-button][data-workshopid="' + workshopId + '"]');
        if ($button.length === 0) {
            self.logger.error('marking workshop button not found');
            return;
        }
        $button.data('workshop-button', 'add');
        $button.removeClass('c-button--secondary');
        $button.addClass('c-button--primary');
        $button.find('.c-button__label').text('Jetzt anmelden');
        $button.find('.c-button__icon-background').removeClass('c-button__icon-background--icon-delete');
        $button.find('.c-button__icon-background').addClass('c-button__icon-background--icon-register');

        if (self.view == 'dashboard') {
            // remove buttons
            $('[data-workshop-section="' + workshopId + '"]').remove();
        }
    }

    countWorkshop(workshopId) {
        let self = this;
        const data = [];
        const uri = '?action=web/countcapacity&workshopid=' + workshopId;
        self.logger.log('Counting Workshop: ', workshopId);
        if (workshopId) {

            // Request Data
            Api.request('GET', uri, data, self.baseUrl)
                .then(function (response) {
                    $('[data-workshop-capacity="' + workshopId + '"]').text(response.count);
                }).catch(function (exception) {
                    self.logger.error('Processor Error', exception);
                    let error_message = 'Es trat ein Fehler auf!';
                    if (typeof exception === 'object'
                        && typeof exception.responseJSON === 'object'
                        && typeof exception.responseJSON.error_code !== 'undefined'
                        && typeof exception.responseJSON.error_message === 'string'
                    ) {
                        error_message = exception.responseJSON.error_message;
                    }
                    alert(error_message);

                });

        }
    }

}

export default new Workshops();
